module.exports = __webpack_public_path__ + "img/add-button.e502b340.svg";